import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button, Alert } from 'react-bootstrap';

import Data from 'components/Data';

import IntlDate from 'components/layout/IntlDate';

import UserBudgetSettings from 'components/modals/UserBudgetSettings';
import may from 'js/security';

class ClientBudget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  show = () => {
    this.setState({ show: true });
  };

  close = () => {
    this.setState({ show: false });
  };

  render() {
    const {
      intl: { messages },
      inModal,
      clientId,
      userBudget,
      user,
    } = this.props;
    const { show } = this.state;

    const budgetActive = !userBudget.pending && !!userBudget.data.budget_definition;

    return (

      <Row>

        <Data dataName="userBudget" url={`/api/users/${clientId}/budget.json`} />

        {!userBudget.pending && (
          <Col xs={12} md={12}>
            <div className="panel panel-transparent">
              <div className="panel-body">
                <h4>{messages.user_budget}</h4>
                <div>
                  {budgetActive ? (
                    <>
                      <dl className="no-margin full-width">
                        {!!userBudget.data.running_budget && (
                          <>
                            <dt>
                              {messages.current_period_budget_usage}{' '}
                              {!!userBudget.data.running_budget.date_to && (
                                <>
                                  (endet <IntlDate date={userBudget.data.running_budget.date_to} />)
                                </>
                              )}
                            </dt>
                            <dd className="p-l-15 m-b-10 p-b-10 b-b b-grey">
                              <div>
                                {messages.budget_value_used}:{' '}
                                <FormattedNumber
                                  value={userBudget.data.running_budget.running_value}
                                  style="currency"
                                  currency={userBudget.data.running_budget.currency}
                                />
                              </div>
                              <div>
                                {messages.budget_value_reserved}:{' '}
                                <FormattedNumber
                                  value={userBudget.data.running_budget.reserved_value}
                                  style="currency"
                                  currency={userBudget.data.running_budget.currency}
                                />
                              </div>
                              <div>
                                {messages.budget_value_residual}:{' '}
                                <FormattedNumber
                                  value={
                                    userBudget.data.running_budget.value -
                                    userBudget.data.running_budget.running_value -
                                    userBudget.data.running_budget.reserved_value
                                  }
                                  style="currency"
                                  currency={userBudget.data.running_budget.currency}
                                />
                              </div>
                            </dd>
                          </>
                        )}

                        <dt>{messages.budget_value}</dt>
                        <dd>
                          <FormattedNumber
                            value={userBudget.data.budget_definition.value}
                            style="currency"
                            currency={userBudget.data.budget_definition.currency}
                          />
                        </dd>
                        <dt className="m-t-5">
                          {messages.recurring}:{' '}
                          {userBudget.data.budget_definition.is_recurring ? (
                            <>
                              {userBudget.data.budget_definition.period === 'week' && messages.week}
                              {userBudget.data.budget_definition.period === 'month' && messages.month}
                              {userBudget.data.budget_definition.period === 'quarter' && messages.quarter}
                            </>
                          ) : (
                            messages.no
                          )}
                        </dt>
                        <dd />
                        <dt className="m-t-5">{messages.date_from}</dt>
                        <dd>
                          <IntlDate date={userBudget.data.budget_definition.date_from} />
                        </dd>
                        <dt className="m-t-5">{messages.date_to}</dt>
                        <dd>
                          {userBudget.data.budget_definition.date_to ? (
                            <IntlDate date={userBudget.data.budget_definition.date_to} />
                          ) : (
                            messages.without_end_date
                          )}
                        </dd>
                      </dl>
                    </>
                  ) : (
                    <Alert bsStyle="info">{messages.no_budget_set}</Alert>
                  )}
                </div>
                <div className="m-t-15 text-right">
               <Button onClick={this.show}>{messages.budget_settings}</Button>
                </div>
              </div>
            </div>
          </Col>
        )}

        <div id="client-budget-settings">
          <UserBudgetSettings
            show={show}
            close={this.close}
            budget={userBudget.data && userBudget.data.budget_definition}
            clientId={clientId}
            onSubmitParent={this.close}
            key={
              (userBudget.data && userBudget.data.budget_definition && userBudget.data.budget_definition.id) || 'new'
            }
          />
        </div>

      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    userBudget: state.data.userBudget,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientBudget));
